import { createContext, useContext } from 'react';
import type { UseStorefrontOptions } from '../hooks/use-storefront-options';

const StorefrontOptionsContext = createContext<UseStorefrontOptions | undefined>(undefined);

export const StorefrontOptionsProvider = StorefrontOptionsContext.Provider;

export function useStorefrontOptionsControls(): UseStorefrontOptions {
  const context = useContext(StorefrontOptionsContext);
  if (!context) {
    throw new Error('useStorefrontOptionsControls must be used within a StorefrontOptionsProvider');
  }
  return context;
}
